import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.tsx';
import { CartProvider } from './context/CartContext.tsx';
import ProtectedRoute from './pages/Login/ProtectedRoutes.tsx';
import CircularProgress from '@mui/material/CircularProgress';
import { ftp_db_config } from './services/config.js';
import MainGrid from './components/MainGrid.tsx';
import Login from './pages/Login/Login.tsx';
import Home from './pages/Home/Home.tsx';
import Configuracoes from './pages/Configuracoes/Configuracoes.tsx';
import Historico from './pages/Historico/Historico.tsx';
import HistoricoFaturado from './pages/Historico/HistoricoFaturado.tsx';

function App() {
  const [empresaConfig, setEmpresaConfig] = useState(null);

  const fetchConfig = async () => {
    try {
      const response = await ftp_db_config();
      setEmpresaConfig(response);
    } catch (err) {
      console.error("Erro ao carregar config:", err);
    }
  };

  useEffect(() => {
    fetchConfig();
  },[]);

  if(!empresaConfig) {
    return <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={40} />
    </div>
  }

  return (
    <Router>
      <CartProvider>
        <AuthProvider>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Home />}>
                  <Route path="home" element={<MainGrid />} />
                  <Route path="configuracoes" element={<Configuracoes />} />
                  <Route path="historico" element={<Historico />}/>
                  <Route path="historico-faturado" element={<HistoricoFaturado />}/>
                </Route>
              </Route>
            </Routes>
        </AuthProvider>
      </CartProvider>
    </Router>
  );
}

export default App;

